import {
  baseUniDriverFactory,
  getDataAttributeValue,
} from '../test-utils/utils/unidriver';

export const sidebarTitleItemNextDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),

    getText: () => base.text(),

    /**
     * Returns the divider skin
     * @returns {Promise<string>}
     */
    getSkin: async () => await getDataAttributeValue(base, 'data-title-skin'),
  };
};
